import * as types from './mutation-types';
import CacheHelper from '@/cacheHelper';
import { isEmpty } from "lodash";

const cacheConfig = {
  key: 'CACHE_KEY',
  ttl: 60 * 5, // 5 mins
}

const cache = new CacheHelper(cacheConfig);

/**
 * All VueX actions should go here.
 * They should check if data exists via the cache, and any api calls should be made to the /flat endpoint by default
 */
export const actions = {
  async getLargestLimit({ rootGetters, commit }) {
    const newsWidgets = rootGetters["widgets/getWidgetsByType"]("links-widget");
    const limits = [];
    let largest = 10;
    if (!isEmpty(newsWidgets)) {
      newsWidgets.forEach((widget) => {
        limits.push(parseInt(widget.props.limit));
      });

      largest = limits.sort((a, b) => b - a)[0];
    }

    commit(types.SET_MAX_QUERY_SIZE, largest);
    console.log("TCL: : getLargestLimit -> largest", largest)
    return Promise.resolve(largest);
  },
  /**
   * Set the filter limit of results
   * TODO: Should this be global?
   */
  async setLimit({ commit }, limit) {
    commit(types.SET_FILTER_LIMIT, limit)
    return Promise.resolve(limit)
  },

  /**
   * Clear localStorage cache
   * * TODO: Should this be global?
   */
  async clearCache(context) {
    cache.removeItem(cacheConfig.key)
    return Promise.resolve(cacheConfig.key)
  },

  async getUserLinks({ dispatch, commit, state }) {
    let response;
    try {
      response = await dispatch('users/getQuickLinks', null, { root: true });
      // restrict to size, sorry mutation
      response.splice(state.largestQuerySize)
      commit(types.SET_LINKS, response);
      return Promise.resolve(response);
    } catch (err) {
      console.error(err);
      return Promise.reject();
    }
  },

  async setFavourite({ dispatch }, link) {
    const { id, priority } = link;

    const payload = {
      priority
    }

    let response;

    try {
      response = await dispatch(`users/editLink`, { payload, id }, { root: true })
      return Promise.resolve(response);
    } catch (err) {
      console.error(err);
      return Promise.reject(err);
    }

  }
};
